import React, { useContext } from 'react';
import { Edges } from 'types';
import { CountryCurrency } from 'helpers';
import { SliceContext } from 'components/Slices/types';
import { PricingTabDocument, CommonPricingTranslations } from '../types';

export type PricingContextModel = {
    pricingTabs: { tab: Partial<PricingTabDocument> }[];
    pricingTabsData: Edges<PricingTabDocument>;
    translations: CommonPricingTranslations;
    countryCurrency: CountryCurrency;
    sliceContext: SliceContext;
};

export const pricingContextDefaultValues = {} as PricingContextModel;
const PricingContext = React.createContext(pricingContextDefaultValues);

export const usePricingContext = () => useContext(PricingContext);

export default PricingContext;
